/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_1_AnswerInputs */

const en_svc_n8n_faq_1_answer = /** @type {(inputs: Svc_N8n_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are an AI automation studio that builds in n8n when it fits and in custom code when it does not. That way the tool follows the process, not the other way round.`)
};

const lv_svc_n8n_faq_1_answer = /** @type {(inputs: Svc_N8n_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esam AI automatizācijas studija. Izstrādājam n8n vidē, kad tas ir piemērots procesam, un pielāgotā kodā, kad vajadzīgs cits risinājums. Tā rīks pielāgojas procesam, nevis otrādi.`)
};

/**
* | output |
* | --- |
* | "We are an AI automation studio that builds in n8n when it fits and in custom code when it does not. That way the tool follows the process, not the other way ..." |
*
* @param {Svc_N8n_Faq_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_1_answer = /** @type {((inputs?: Svc_N8n_Faq_1_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_1_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_1_answer(inputs)
	return en_svc_n8n_faq_1_answer(inputs)
});